<template>
  <div class="admin-referral">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4 class="mb-0 text-white">邀请记录管理</h4>
    </div>

    <!-- 记录表格 -->
    <div class="card bg-dark-soft border-0 shadow-sm">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-dark table-hover mb-0">
            <thead>
              <tr>
                <th>ID</th>
                <th>时间</th>
                <th>邀请人</th>
                <th>被邀请人</th>
                <th>奖励积分</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td>{{ item.id }}</td>
                <td>{{ item.created_at }}</td>
                <td>
                  <div class="text-primary font-weight-bold">{{ item.referrer.name }}</div>
                  <small class="text-muted">ID: {{ item.referrer.id }}</small>
                </td>
                <td>
                  <div class="text-success font-weight-bold">{{ item.referee.name }}</div>
                  <small class="text-muted">ID: {{ item.referee.id }}</small>
                </td>
                <td>
                  <span class="badge badge-pill badge-warning">+{{ item.points }}</span>
                </td>
                <td>
                  <span v-if="item.status === 0" class="badge badge-warning">审核中</span>
                  <span v-else-if="item.status === 2" class="badge badge-danger">未通过</span>
                  <span v-else class="badge badge-success">已通过</span>
                </td>
                <td>
                  <template v-if="item.status === 0">
                    <button class="btn btn-sm btn-success mr-2" @click="audit(item.id, true, item.status)">通过</button>
                    <button class="btn btn-sm btn-danger" @click="audit(item.id, false, item.status)">拒绝</button>
                  </template>
                  <template v-else-if="item.status === 1">
                    <button class="btn btn-sm btn-outline-danger" @click="audit(item.id, false, item.status)">改未通过</button>
                  </template>
                  <span v-else class="text-muted">-</span>
                </td>
              </tr>
              <tr v-if="items.length === 0 && !loading">
                <td colspan="7" class="text-center py-5 text-muted">暂无邀请记录</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <!-- 分页 -->
      <div class="card-footer bg-transparent border-top border-secondary d-flex justify-content-between align-items-center py-3">
        <div class="text-muted small">
          共 {{ total }} 条记录
        </div>
        <div class="pagination-controls d-flex">
          <button 
            class="btn btn-sm btn-outline-secondary mr-2" 
            :disabled="page <= 1"
            @click="changePage(page - 1)"
          >
            上一页
          </button>
          <div class="align-self-center px-2 text-white">第 {{ page }} 页</div>
          <button 
            class="btn btn-sm btn-outline-secondary ml-2" 
            :disabled="page * page_size >= total"
            @click="changePage(page + 1)"
          >
            下一页
          </button>
        </div>
      </div>
    </div>

    <!-- 加载中 -->
    <div v-if="loading" class="loading-overlay d-flex justify-content-center align-items-center">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  </div>
</template>

<script>
import { request_zzquant } from '@/network/request'

export default {
  name: 'AdminReferral',
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      page: 1,
      page_size: 20
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      request_zzquant({
        url: '/v3/user/referral/admin/list',
        params: {
          page: this.page,
          page_size: this.page_size
        }
      }).then(res => {
        if (res.data.code === 20000) {
          this.items = res.data.data.items
          this.total = res.data.data.total
        }
      }).finally(() => {
        this.loading = false
      })
    },
    changePage(p) {
      this.page = p
      this.fetchData()
    },
    audit(record_id, is_pass, currentStatus) {
      let targetAction = '通过'
      if (!is_pass) {
        targetAction = currentStatus === 1 ? '改为未通过并扣回积分' : '拒绝'
      }
      
      this.$bvModal.msgBoxConfirm(`确定要${targetAction}这条记录吗？`, {
        title: '操作确认',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: is_pass ? 'success' : 'danger',
        okTitle: '确定',
        cancelTitle: '取消',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (value) {
          this.loading = true;
          request_zzquant({
            url: '/v3/user/referral/admin/audit',
            method: 'POST',
            data: {
              record_id: record_id,
              is_pass: is_pass
            }
          }).then(res => {
            if (res.data.code === 20000) {
              this.$bvToast.toast('审核操作成功', { title: '成功', variant: 'success', solid: true });
              this.fetchData();
            } else {
              this.$bvToast.toast(res.data.msg || '审核失败', { title: '错误', variant: 'danger', solid: true });
              this.loading = false;
            }
          }).catch(() => {
            this.loading = false;
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.bg-dark-soft {
  background: #1e293b;
}
.loading-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  z-index: 1000;
}
.table th {
  border-top: none;
  background: #0f172a;
  color: #94a3b8;
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.table td {
  vertical-align: middle;
  border-top: 1px solid #2d3d51;
}
.badge-warning {
  background-color: #f59e0b;
  color: #000;
}
</style>
